export default __webpack_public_path__ + "static/media/emergencia.84da9acb.jpg";